var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-form',{on:{"clickLogin":function($event){return _vm.clickLogin($event)},"signup":function($event){return _vm.signup($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }